import { useTranslations } from 'next-intl';
import styles from './selected-equipment-drawer.module.scss';
import cx from 'classnames';

export const SelectedEquipmentActionButton = ({
  text,
  onClick,
  children,
}: {
  text: string;
  onClick?: () => void;
  children: React.ReactNode;
}) => {
  const t = useTranslations();
  return (
    <button
      className={cx([`p-0`, styles['equipment-actions__button']])}
      onClick={onClick}
    >
      <div className={styles['equipment-actions__button--withBackground']}>
        {children}
      </div>
      <label
        className={cx([
          'px-2 pt-2 m-0',
          'cat-u-theme-typography-label-sm',
          styles['equipment-actions__button--label'],
        ])}
      >
        {t(text)}
      </label>
    </button>
  );
};
